import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import AppContainer from './AppContainer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>
);

